const getIconSize = ({ isSmall, isVertical, showImage })=>{
    const horizontalIconSize = isSmall ? '16' : '20';
    const verticalIconSizeWithoutImage = isSmall ? '24' : '32';
    const verticalIconSizeWithImage = isSmall ? '20' : '24';
    const verticalIconSize = showImage ? verticalIconSizeWithImage : verticalIconSizeWithoutImage;
    return isVertical ? verticalIconSize : horizontalIconSize;
};
export { getIconSize };
